
import axios from 'axios';

export default (token = false) => {
    
    return axios.create({
        baseURL: 'https://fb-api.redorch.com/admin/sailor/v1/',
        headers: {
             'content-type': 'application/json',
             
            'authorization': `Bearer ${token}`
        }
    })
}